import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { slugify } from "../../../Shared/utils/string";
import { getDrupalVacancies } from "../../custom_api/api";
import { library } from "../../libraries";
import { Teaser } from "./teaser";
export class VacancyOverviewBlock extends React.Component {
    async componentDidMount() {
        const categoryId = this.props.category_id;
        if (categoryId === null) {
            this.setState((s)=>({
                    ...s,
                    vacancies: List()
                }));
            return;
        }
        let vacanciesData = await getDrupalVacancies(List([
            categoryId
        ]));
        if (vacanciesData !== "error") {
            this.setState((s)=>({
                    ...s,
                    vacancies: List(vacanciesData)
                }));
        }
    }
    render() {
        const copy = library().copy.vacancies;
        let p = this.props;
        let s = this.state;
        const placeholderText = p.placeholder ?? copy.noVacanciesFound;
        return /*#__PURE__*/ _jsxs("section", {
            className: "block block--content-grid block--vacancies container--lg align--center",
            children: [
                (p.title || p.html) && /*#__PURE__*/ _jsxs("header", {
                    className: "block__header container--m align--center",
                    children: [
                        /*#__PURE__*/ _jsx("h2", {
                            "data-anchor": p.title ? slugify(p.title) : undefined,
                            className: "block__title title--l container--xs",
                            children: p.title
                        }),
                        p.html && /*#__PURE__*/ _jsx("div", {
                            dangerouslySetInnerHTML: {
                                __html: p.html
                            },
                            className: "block__intro container--s text--styled"
                        })
                    ]
                }),
                s.vacancies !== 'error' && s.vacancies !== 'loading' && (!s.vacancies.isEmpty() ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: /*#__PURE__*/ _jsx("ul", {
                        className: "teasers row",
                        children: s.vacancies.map((v, i)=>/*#__PURE__*/ _jsx(Teaser, {
                                extraClasses: "vacancy col-xs-12 col-sm-6",
                                linkUrl: v.url,
                                headingLevel: "h3",
                                title: v.title,
                                intro: v.subtitle,
                                locationFooter: v.locations.split(',').length == 1 ? v.locations : "Meerdere locaties"
                            }, `vacancy_overview_${i}`))
                    })
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "text--styled",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "weight--bold container--s",
                        children: placeholderText
                    })
                }))
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = {
            vacancies: "loading"
        };
    }
}
{}